module.exports = __webpack_public_path__ + "img/image.f2b1ce51.png";